// constants
const initialState = {
  name: '',
  age: '',
  phone: ''
};

export const SELECT_PERSON = 'SELECT_PERSON';

// actions
export const selectPerson = (person) => {
  return {
    type: SELECT_PERSON,
    payload: person
  };
};

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_PERSON:
      return {
        ...state,
        name: action.payload.name,
        age: action.payload.age,
        phone: action.payload.phone
      };
    default:
      return state;
  }
}
